import styled from 'styled-components';
import { FONTS, COLORS } from '@app/src/ui';

export const Wrapper = styled.footer`
  font-family: ${FONTS.OPEN_SANS};
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 40px;
  text-align: center;
  color: ${COLORS.GRAY_DARK};
  height: 40px;
  margin: 12px 0 0;
`;
